
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitoashtavinayakdarshancab() {



    const cardData =
    {
        keyword: 'Mumbai to Ashtavinayak Darshan Cab',
        heading: 'S9 Travels: Mumbai to Ashtavinayak Darshan Cab',
        headingDescription: 'S9 Travels offers Mumbai to Ashtavinayak Darshan Cab Service, providing a comfortable, safe, and hassle-free pilgrimage experience. Visit all eight revered Ashtavinayak Ganpati temples with our well-maintained cabs, including spacious Innova and SUVs, ensuring a smooth and spiritual journey. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Mumbai to Ashtavinayak Darshan Cab with S9 Travels and embark on a divine and stress-free journey!',


        top: 'Top Places to Visit in Ashtavinayak with S9 Travels',

"topPlaces": [
    {
      "title": "Mayureshwar Ganpati, Morgaon",
      "description": "Located in Morgaon, this temple is considered the most important of the Ashtavinayak temples. According to legend, Lord Ganesha took the form of Mayureshwar (riding a peacock) to defeat the demon Sindhu. The temple’s architecture is beautiful, with a central Ganesha idol covered in saffron and surrounded by a grand entrance gate. Devotees believe that a visit here marks the beginning and end of the Ashtavinayak pilgrimage."
    },
    {
      "title": "Siddhivinayak Ganpati, Siddhatek",
      "description": "Situated on the banks of the Bhima River, Siddhatek is home to the Siddhivinayak Temple, where Lord Vishnu is said to have worshipped Ganesha before defeating the demons Madhu and Kaitabha. The temple is built from black stone and is believed to fulfill devotees' wishes when they complete pradakshina (circumambulation) around the hill."
    },
    {
      "title": "Ballaleshwar Ganpati, Pali",
      "description": "Located in Pali, this temple is named after Ballal, a devout child who was blessed by Ganesha. Unlike other Ashtavinayak temples, this one has an idol facing east with its trunk turned to the right, signifying power. The temple is surrounded by the scenic Sahyadri hills, making it a peaceful pilgrimage site."
    },
    {
      "title": "Varadvinayak Ganpati, Mahad",
      "description": "Situated in Mahad near Khopoli, this temple is associated with the legend of a prince named Rukmangada, who was blessed by Lord Ganesha in the form of Varadvinayak (the giver of boons). The temple allows devotees to personally touch and worship the idol, which is a rare practice in Hindu temples."
    },
    {
      "title": "Chintamani Ganpati, Theur",
      "description": "Located near Pune, this temple is where Lord Ganesha helped sage Kapila retrieve the wish-fulfilling jewel, Chintamani, from an arrogant king. Theur is also known for its peaceful surroundings and spiritual ambiance, making it a popular destination for meditation and prayers."
    },
    {
      "title": "Girijatmaj Ganpati, Lenyadri",
      "description": "This temple is unique because it is carved out of a single rock in the Lenyadri caves. It is believed to be the place where Goddess Parvati performed penance to have Lord Ganesha as her son. Devotees must climb around 300 steps to reach the temple, but the panoramic view of the surroundings makes the journey worthwhile."
    },
    {
      "title": "Vighnahar Ganpati, Ozar",
      "description": "Situated in Ozar, this temple is dedicated to Ganesha as Vighnahar, the remover of obstacles. According to legend, Lord Ganesha defeated the demon Vighnasura here, bringing peace to the land. The temple features intricate carvings and a golden dome, making it one of the most visually striking Ashtavinayak temples."
    },
    {
      "title": "Mahaganpati, Ranjangaon",
      "description": "Located in Ranjangaon near Pune, this temple is associated with the legend of Lord Shiva invoking Ganesha’s blessings before defeating the demon Tripurasura. The idol is said to be very powerful, and some believe that a hidden idol inside the sanctum is even larger than what is visible to devotees."
    }
],

"services": [
  {
    "name": "Mumbai to Ashtavinayak Darshan Cab Service",
    "description": "S9 Travels offers reliable Mumbai to Ashtavinayak Darshan cab services, ensuring a comfortable and spiritual journey to all eight Ashtavinayak temples. Our well-maintained cabs and professional drivers make your pilgrimage trip smooth, safe, and enjoyable."
  },
  {
    "name": "Book Mumbai to Ashtavinayak Taxi",
    "description": "Booking a taxi for your Ashtavinayak Darshan from Mumbai is easy with S9 Travels. Whether you're planning a one-day trip or a two-day pilgrimage, we provide flexible options and reliable taxis to ensure a convenient journey to all Ashtavinayak temples."
  },
  {
    "name": "Affordable Mumbai to Ashtavinayak Pilgrimage Taxi",
    "description": "S9 Travels offers affordable Mumbai to Ashtavinayak pilgrimage taxi services. We provide cost-effective options without compromising on comfort or safety. Whether you're traveling alone, with family, or in a group, we offer budget-friendly packages for your Ashtavinayak Darshan journey."
  },
  {
    "name": "Private Taxi for Ashtavinayak Darshan from Mumbai",
    "description": "For a personalized experience, opt for a private taxi for Ashtavinayak Darshan from Mumbai. S9 Travels offers dedicated cabs, allowing you to travel at your own pace and convenience. Our experienced chauffeurs will guide you on your pilgrimage, ensuring a peaceful and hassle-free experience."
  },
  {
    "name": "Mumbai to Ashtavinayak One-Way or Round Trip",
    "description": "S9 Travels offers one-way and round-trip taxi services for your Mumbai to Ashtavinayak Darshan. Whether you're planning a quick one-day trip or a round trip covering all the Ashtavinayak temples, our flexible services provide the best solution for your pilgrimage journey."
  },
  {
    "name": "Ashtavinayak Temple Tour by Taxi",
    "description": "Explore the Ashtavinayak temples with a dedicated taxi tour from Mumbai. S9 Travels provides a guided temple tour, ensuring you visit each of the eight temples in comfort and with the best possible service. Our experienced drivers ensure that your spiritual journey is smooth and enriching."
  },
  {
    "name": "Comfortable Travel from Mumbai to Ashtavinayak",
    "description": "Enjoy comfortable travel from Mumbai to Ashtavinayak with S9 Travels. Our taxis are well-maintained, and our professional chauffeurs ensure a safe and relaxing journey to each of the Ashtavinayak temples. Whether you're traveling solo or in a group, we prioritize your comfort throughout the trip."
  },
  {
    "name": "Luxury Taxi for Ashtavinayak Darshan",
    "description": "Travel in style with a luxury taxi for your Ashtavinayak Darshan from Mumbai. S9 Travels offers high-end vehicles equipped with premium amenities for a comfortable and luxurious pilgrimage journey. Whether you're looking for a premium experience for yourself or for a group, our luxury taxis ensure a memorable journey."
  },
  {
    "name": "Group Travel to Ashtavinayak from Mumbai",
    "description": "S9 Travels provides group travel services for your Ashtavinayak pilgrimage from Mumbai. We offer spacious vehicles to accommodate your family or group, ensuring a comfortable and coordinated journey to all eight Ashtavinayak temples. With our professional drivers, your group trip will be well-organized and stress-free."
  }
],

"tableData": [
  ["Mumbai to Ashtavinayak Darshan Cab Service", "Book Mumbai to Ashtavinayak Taxi"],
  ["Affordable Mumbai to Ashtavinayak Pilgrimage Taxi", "Private Taxi for Ashtavinayak Darshan from Mumbai"],
  ["Mumbai to Ashtavinayak One-Way or Round Trip", "Ashtavinayak Temple Tour by Taxi"],
  ["Comfortable Travel from Mumbai to Ashtavinayak", "Luxury Taxi for Ashtavinayak Darshan"],
  ["Group Travel to Ashtavinayak from Mumbai", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Devotional Journey",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Ashtavinayak Darshan cab service, ideal for those looking to embark on a spiritual journey. Our well-maintained vehicles, including the Toyota Innova, ensure a smooth, peaceful ride with ample space, air conditioning, and plush seating to make your Darshan trip truly comfortable."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedcription": "We understand the importance of timing for your spiritual journey. Our Mumbai to Ashtavinayak Darshan cab service ensures punctual pick-ups and drop-offs, so you can visit all eight Ganesh temples without any delays and at your own pace."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes for the Ashtavinayak Darshan trip. They are courteous, knowledgeable, and ensure a safe and smooth ride, providing you with a stress-free journey during your spiritual visit."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Mumbai to Ashtavinayak Darshan cab services. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your trip budget with ease."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Darshan Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features such as GPS tracking, airbags, and seat belts, ensuring a secure and comfortable journey while you embark on your spiritual journey to Ashtavinayak."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Ashtavinayak Darshan trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your schedule and convenience."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Darshan Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you prefer to visit all the temples in a specific order or require special arrangements along the way, we offer customizable itineraries to suit your preferences and ensure your Ashtavinayak Darshan trip is as fulfilling as possible."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to Ashtavinayak Darshan cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance to make your booking experience smooth and easy."
  }
]











    }

    const faqData = [
        [
          {
            question: 'How can I book an Ashtavinayak Darshan cab from Mumbai?',
            answer: 'Booking an Ashtavinayak Darshan cab from Mumbai is easy! You can make a reservation through our website, mobile app, or by contacting our customer service team. We ensure a smooth and timely journey to all the Ashtavinayak temples.',
          },
          {
            question: 'What types of vehicles are available for Ashtavinayak Darshan from Mumbai?',
            answer: 'We offer a variety of vehicles for your Ashtavinayak Darshan trip from Mumbai, including sedans, SUVs, and luxury vehicles like the Toyota Innova. Choose the vehicle that best suits your group size and comfort preferences.',
          },
          {
            question: 'Are the drivers experienced for Ashtavinayak Darshan trips from Mumbai?',
            answer: 'Yes, our drivers are highly experienced and familiar with the Ashtavinayak route. They ensure a safe, smooth, and comfortable journey while providing you with the best experience during your Darshan.',
          },
          {
            question: 'How long does the Ashtavinayak Darshan trip from Mumbai take?',
            answer: 'The Ashtavinayak Darshan trip from Mumbai typically takes 2-3 days, as it involves visiting eight temples across different locations. However, we can customize the itinerary to suit your schedule and preferences.',
          },
          {
            question: 'Can I book a one-day trip for Ashtavinayak Darshan from Mumbai?',
            answer: 'While it’s possible to complete the trip in one day, it may feel rushed. For a more relaxed experience, we recommend booking a 2-day trip. However, we can customize the itinerary based on your preferences.',
          },
          {
            question: 'Is there a fixed fare for the Ashtavinayak Darshan cab service from Mumbai?',
            answer: 'The fare for the Ashtavinayak Darshan trip from Mumbai depends on the vehicle type, trip duration, and additional requirements. Contact us for a customized quote, and we’ll provide transparent pricing for your journey.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai for Ashtavinayak Darshan?',
            answer: 'Yes, we provide convenient pick-up services from anywhere in Mumbai, including hotels, homes, or specific locations for your Ashtavinayak Darshan trip. Our drivers will ensure you have a comfortable and timely start to your journey.',
          },
          {
            question: 'Can I request a specific itinerary for the Ashtavinayak Darshan trip?',
            answer: 'Yes, you can request a customized itinerary based on your preferences. Whether you wish to visit specific temples or add other places of interest, we can tailor the trip to suit your needs.',
          },
          {
            question: 'Do you offer additional services like meals and sightseeing during the Ashtavinayak Darshan trip?',
            answer: 'Yes, we can arrange for meals and sightseeing on the way during your Ashtavinayak Darshan trip. Simply let us know your preferences, and we’ll include them in your itinerary.',
          },
          {
            question: 'Why should I choose S9 Travels for my Ashtavinayak Darshan cab service from Mumbai?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cabs for Ashtavinayak Darshan trips from Mumbai. With experienced drivers, well-maintained vehicles, and exceptional customer service, we ensure you have a memorable and spiritual journey to all the Ashtavinayak temples.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Devotee',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an Ashtavinayak Darshan trip with S9 Travels from Mumbai, and it was a wonderful experience. The vehicle was comfortable, and the driver was experienced and friendly. The journey was peaceful, and the temples were beautiful. I highly recommend S9 Travels for anyone looking to go on an Ashtavinayak Darshan trip!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Devotee',
          rating: [1, 1, 1, 1, 1],
          text: '“Our Ashtavinayak Darshan trip from Mumbai with S9 Travels was truly memorable. The driver was knowledgeable about the route, and the vehicle was clean and comfortable. We had a smooth and spiritual journey, visiting all the temples in a relaxed manner. We will definitely use S9 Travels again for our next trip.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
      
      


    return (
        <div>
        

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoashtavinayakdarshancab;